import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import BookingPage from "./pages/BookingPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import PatientDashboard from "./pages/PatientDashboard";
import AdminSetup from "./pages/AdminSetup";
import ApprovalResult from "./pages/ApprovalResult";
import AdminDashboard from "./pages/AdminDashboard";
import TreatmentPage from "./pages/TreatmentPage";

function App() {
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main Pages with Layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />

          {/* Treatment Pages */}
          <Route path="/homeopathy-for-psoriasis" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-eczema" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-vitiligo" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-acne" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-urticaria" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-hair-fall" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-alopecia" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-dandruff" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-sinusitis" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-allergic-rhinitis" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-asthma" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-pcos" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-thyroid" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-migraine" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-anxiety" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-insomnia" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/homeopathy-for-enlarged-adenoids" element={<Layout><TreatmentPage /></Layout>} />
          <Route path="/piles-fissure-or-fistula" element={<Layout><TreatmentPage /></Layout>} />

          {/* Booking Flow */}
          <Route path="/book" element={<Layout><BookingPage /></Layout>} />
          <Route path="/booking-success" element={<Layout><BookingSuccessPage /></Layout>} />
          
          {/* Patient Dashboard (token-based access) */}
          <Route path="/dashboard/:bookingId" element={<Layout><PatientDashboard /></Layout>} />
          <Route path="/bookings/:bookingId" element={<Layout><PatientDashboard /></Layout>} />
          
          {/* Admin Pages */}
          <Route path="/admin/setup" element={<AdminSetup />} />
          <Route path="/admin/approval-result" element={<ApprovalResult />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
